import React from "react";

import { cn } from "@/utils";

/**
 * Глобальный footer (40px, full-width).
 *
 * Слева: copyright + версия (моно).
 * Справа: документация (страница «Информация о ПО» на сайте) / поддержка / статус.
 */
export const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const version = (import.meta.env.VITE_APP_VERSION as string) || "v2.2.0";

  return (
    <footer
      className={cn(
        "fixed bottom-0 left-0 right-0 z-30",
        "h-10 px-5 flex items-center gap-4",
        "bg-surface-canvas border-t border-line",
        "text-fs-xs text-ink-3",
      )}
    >
      <div className="flex items-center gap-3.5">
        <span className="hidden sm:inline">© {year} Inforensic</span>
        <span className="font-mono text-fs-2xs text-ink-4">{version}</span>
      </div>

      <div className="flex-1" />

      <div className="flex items-center gap-3 sm:gap-[18px] whitespace-nowrap">
        <a
          href="https://inforensic.pro/info"
          target="_blank"
          rel="noopener noreferrer"
          className="text-ink-2 hover:text-ink-1 transition-colors"
        >
          Документация
        </a>
        <a href="mailto:support@inforensic.pro" className="text-ink-2 hover:text-ink-1 transition-colors">
          Поддержка
        </a>
        {/* Живое состояние — signal, как на inforensic.pro, а не «успех» */}
        <span className="inline-flex items-center gap-1.5 font-mono text-fs-2xs uppercase tracking-[0.12em] text-signal">
          <span className="w-1.5 h-1.5 rounded-full bg-signal" />
          Все системы
        </span>
      </div>
    </footer>
  );
};

export default Footer;
